import { h } from 'preact';

export const SignUpTwoIcon = () => (

<svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0)">
<path d="M28.6058 57C44.2876 57 57.0002 44.2401 57.0002 28.5C57.0002 12.7599 44.2876 0 28.6058 0C12.924 0 0.211426 12.7599 0.211426 28.5C0.211426 44.2401 12.924 57 28.6058 57Z" fill="#9EB35E"/>
<path d="M13.8252 22.9132C16.7587 14.0046 26.3488 9.17283 35.2244 12.1172C44.1 15.0616 48.9139 24.6874 45.9804 33.596" fill="#131410"/>
<path d="M14.7279 43.7881C12.8099 38.6166 15.4424 32.8411 20.5948 30.9159C25.7472 28.9908 31.5013 31.6332 33.4193 36.8047" fill="#5F6D3B"/>
</g>
<defs>
<clipPath id="clip0">
<rect width="56.7887" height="57" fill="white" transform="translate(0.211426)"/>
</clipPath>
</defs>
</svg>

);

